/*eslint-disable*/
import $urls from '../urls/url';
import $api from '../axios/index';
import request from "../axios/request";
import $Cookies from 'js-cookie';
import {
  store
} from '@/common/index';
import common from './common'

// 登陆前接口
const HOMEBEFORE = {
    // 获取注册的时候是否需要真实姓名
    agentCodeCache(params) {
      return new Promise((resolve, reject) => {
        $api.get(
          $urls.HOMEBEFORE.agentCodeCache+'?code='+params.code,{},
          resp => {
            if (resp.status == 200) {
              resolve(resp.data.data);
            }
          },
          err => reject(err)
        );
      });
    },
  // 获取注册的时候是否需要真实姓名
  queryNeedRealName(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEBEFORE.queryRealName,
        params || {},
        resp => {
          if (resp.status == 200) {
            resolve(resp.data.data);
          }
        },
        err => reject(err)
      );
    });
  },
  // 初始化链接
  initLink() {
    let params = {};
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEBEFORE.init,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            reject(resp.data.msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  withdrawInit() {
    let params = {};
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEBEFORE.withdrawInit,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            reject(resp.data.msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  // 首页优惠导航
  queryIndexOfferList() {
    let params = {};
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEBEFORE.queryIndexOfferList,
        params,
        resp => {
          if (resp.data.success) {
            let data = resp.data.data;
            resolve(data);
          } else {
            reject(resp.data.msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  // 根据Code获取配置图片
  fetchImgs(imgCode) {
    let params = {
      imgCodes: imgCode
    };
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEBEFORE.fetchImgs,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data.data);
          } else {
            resolve([]);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  fetchImg(imgCode) {
    let params = {
      imgCode: imgCode
    };
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEBEFORE.fetchImg,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data.data);
          } else {
            resolve([]);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },

  // 老虎机图片地址
  serverInfo() {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEBEFORE.serverInfo,
        {},
        resp => {
          if (resp.data.code === 200) {
            let serverInfo = resp.data.data.serverInfo;
            let picLink = serverInfo.ftpDomain;
            store.dispatch("setSlotPic", picLink);
            resolve(picLink);
          } else {
            reject(resp.data.msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },

  // 客服链接
  service() {
    return new Promise((resolve, reject) => {
      let params = {
        appVersion: 1.0,
        appType: "pc"
      };
      $api.post(
        $urls.HOMEBEFORE.service,
        params,
        resp => {
          if (
            resp.data.code === 110 ||
            resp.data.code === 111 ||
            resp.data.code === 200
          ) {
            let customerUrl = resp.data.data.customerUrl;
            resolve(customerUrl);
          } else {
            reject(resp.data.msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },

  // 游戏平台
  // 游戏类型:1 - 老虎机，2-真人，3-体育，4-彩票，5-捕鱼王，6-棋牌，7-3D厅
  gamePlatform(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.GAME.gamePlatform,
        params,
        resp => {
          if (resp.data.code === 200) {
            let gameForm = resp.data.data;
            resolve(gameForm);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  // 热门
  heatGamePlatform(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.GAME.heatGamePlatform,
        params,
        resp => {
          if (resp.data.code === 200) {
            let gameForm = resp.data.data;
            resolve(gameForm);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  queryAllGameList(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.GAME.queryAllGameList,
        params,
        resp => {
          if (resp.data.code === 200) {
            let gameForm = resp.data.data;
            resolve(gameForm);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  allGameInfo() {
    // gameType:1 - 老虎机，2-真人，3-体育，4-彩票，5-捕鱼王，6-棋牌，7-3D厅
    return new Promise((resolve, reject) => {
      let params = {};
      $api.post(
        $urls.HOMEBEFORE.allGameInfo,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            if (data.length > 0) {
              resolve(data);
            }
          } else {
            resolve([]);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  // 游戏平台图片
  platformPicInfo(params = {}) {
    // let params = {
    //   frontType: 2,
    //   gameType : -1,
    // };
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEBEFORE.platformPicInfo,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else if (resp.data.code === 201) {
            resolve([]);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },

  // 获取最热游戏列表
  getGameList() {
    return new Promise((resolve, reject) => {
      let pageNo = 1;
      let pageSize = 36;
      let params = {
        frontType: store.state.frontType,
        pageNo: pageNo,
        pageSize: pageSize
      };
      $api.post(
        $urls.HOMEBEFORE.GAMELIST,
        params,
        resp => {
          if (resp.data.code === 200) {
            let gameList = resp.data.data.list;
            let data = common.joint(
              store.state.picLink,
              gameList,
              store.state.mySlot
            );
            resolve(data);
          } else {
            resolve([]);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 获取最热游戏列表
  getGameListByNum(num) {
    // num个数
    return new Promise((resolve, reject) => {
      let pageNo = 1;
      let pageSize = num;
      let params = {
        frontType: store.state.frontType,
        pageNo: pageNo,
        pageSize: pageSize
      };
      $api.post(
        $urls.HOMEBEFORE.GAMELIST,
        params,
        resp => {
          if (resp.data.code === 200) {
            let gameList = resp.data.data.list;
            let data = common.joint(
              store.state.picLink,
              gameList,
              store.state.mySlot
            );
            resolve(data);
          } else {
            resolve([]);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 游戏页面banner
  getBannerList(id) {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType,
        position: id
      };
      $api.post(
        $urls.HOMEBEFORE.BANNERLIST,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data.list;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {}
      );
    });
  },
  // 一级导航
  getFirstNav() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType
      };
      $api.post(
        $urls.HOMEBEFORE.FIRSTNAVLIST,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  // 首页导航
  getFirstNavList() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType
      };
      $api.post(
        $urls.HOMEBEFORE.FIRSTNAVLIST,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            if (data.length > 0) {
              data.forEach((item, index, arr) => {
                arr[index]["url"] = common.sortIndexNav(item.type);
              });
            }
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 获取公告
  pushInfoList() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: 2
      };
      $api.post(
        $urls.HOMEBEFORE.PUSHINFOLIST,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data.list;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 挂件图片
  floatPicList() {
    return new Promise((resolve, reject) => {
      let params = {};
      $api.post(
        $urls.HOMEBEFORE.floatPicList,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  }
};
// 登陆后接口
const HOMEAFTER = {
  // 领取奖励
  minLimit(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEAFTER.getminLimit,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  receivePromoteGift(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEAFTER.receivePromoteGift,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 获取邀请数据
  queryPromoteInfo(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEAFTER.queryPromoteInfo,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 登录信息
  logedUserInfo() {
    let browser = common.getBrowserInfo();
    let UUID = $Cookies.get("UUID");
    let deviceId = $Cookies.get("deviceId");
    if (deviceId === undefined || deviceId === "") {
      let timeStr = new Date().getTime().toString();
      let str = Math.random()
        .toString()
        .slice(-6);
      deviceId = timeStr + str;
      $Cookies.set("deviceId", deviceId, {
        expires: 2000
      });
    }

    let params = {
      UUID: UUID,
      browser: browser,
      deviceId: deviceId
      // domain: document.domain,
      // ipInfo: ' ',
    };

    $api.post(
      $urls.HOMEAFTER.logedUserInfo,
      params,
      resp => {
        if (resp.data.code === 200) {
          common.deviceInfo();
        } else {
        }
      },
      err => {}
    );
  },
  // 设备信息
  deviceInfo() {
    let UUID = $Cookies.get("UUID");
    let deviceId = $Cookies.get("deviceId");

    let info = common.getOsInfo();
    let os = "",
      osVersion = "";
    info.name && (os = info.name);
    info.version && (osVersion = info.version);

    let params = {
      frontType: store.state.frontType,
      UUID: UUID,
      deviceId: deviceId,
      ip: "",
      clientTime: new Date().getTime(),
      isp: "",
      os: os,
      osVersion: osVersion,
      dns: "",
      dnsLocation: "",
      proxy: "",
      country: "",
      province: "",
      city: "",
      zipCode: "",
      timeZone: "",
      cookieEnable: "",
      jsEnable: "",
      flashEnable: "",
      javaEnable: "",
      activexEnable: "",
      webrtcEnable: "",
      vbEnable: "",
      adblockEnable: "",
      latitude: "",
      longitude: "",
      language: navigator.language,
      deviceMemory: "",
      maxTouchPoints: "",
      hardwareConcurrency: "",
      cpu: "",
      colorDepth: "",
      displayWidth: "",
      displayHeight: ""
    };
    $api.post(
      $urls.HOMEAFTER.DEVIVEINFO,
      params,
      resp => {
        if (resp.data.code === 200) {
        } else {
        }
      },
      err => {}
    );
  },
  // 刷新登录状态
  refreshUserInfo() {
    let params = {
      UUID: store.state.UUID
    };
    $api.post(
      $urls.HOMEAFTER.refresh,
      params,
      resp => {},
      err => {}
    );
  },
  // 查询会员账户锁定金额记录
  queryUserLockAmount(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEAFTER.queryUserLockAmount,
        params,
        resp => {
          if (resp.data.code === 200) {
            let gameList = resp.data.data.list;
            let gameInfo = resp.data.data;
            let result = {
              lockList: gameList,
              lockInfo: gameInfo
            };
            resolve(result);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            let result = {
              lockList: [],
              lockInfo: {
                pageNum: 0,
                infoPageSize: 0,
                total: 0
              }
            };
            resolve(result);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 会员自助解锁锁定金额
  selfUnlockAmount(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEAFTER.selfUnlockAmount,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 最低取款额
  getminLimit(params) {
    let UUID = $Cookies.get("UUID");
    params = {
      UUID: UUID
    };
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEAFTER.getminLimit,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            let result = {};
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 判断是否代理注册
  queryAgentBonus(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEAFTER.queryAgentBonus,
        params,
        resp => {
          if (resp.data.success) {
            resolve(resp.data.data);
          } else {
            reject();
          }
        },
        err => {
          reject();
        }
      );
    });
  },
  getfrontconfig(params) {
    // let UUID = $Cookies.get('UUID');
    params = {
      configKey: params.configKey,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.getfrontconfig, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          let result = {
            lockList: [],
            lockInfo: {
              pageNum: 0,
              infoPageSize: 0,
              total: 0,
            }
          }
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 365代理所有联系方式
  getFrontConfigList(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.HOMEAFTER.getFrontConfigList,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            let result = {};
          }
        },
        err => {
          reject(err);
        }
      );
    });
  }
};

const USER = {
  // 登出
  loginOut() {
    store.dispatch('checkLogin');
    let UUID = $Cookies.get('UUID');
    if (UUID) {
      return new Promise((resolve, reject) => {
        $api.post($urls.USER.LOGINOUT, {
          UUID: UUID
        }, (resp) => {
          if (resp.data.code === 200) {
            $Cookies.remove('UUID');
            store.dispatch('checkLogin');
            resolve('退出登录')
          } else {
            reject(resp.data.msg);
          }
        }, err => {
          reject(err.message);
        })
      })
    }
  },
  // 用户信息
  getUserInfo() {
    return new Promise((resolve, reject) => {
      let browser = common.getBrowserInfo(); //取到完整信息
      let UUID = $Cookies.get('UUID');
      let deviceId = $Cookies.get('deviceId');
      if (deviceId === undefined || deviceId === '') {
        let timeStr = new Date().getTime().toString();
        let str = Math.random().toString().slice(-6);
        deviceId = timeStr + str;
        $Cookies.set('deviceId', deviceId, {
          expires: 2000
        });
      }
      let params = {
        UUID: UUID,
        browser: browser,
        deviceId: deviceId,
        domain: document.domain,
        ipInfo: '',
      };

      $api.post($urls.USER.FIRSTUSERINFO, params, (resp) => {
        if (resp.data.code === 200) {
          let userInfo = resp.data.data;
          resolve(userInfo)
        } else {
          resp.data.msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })

    })
  },
  // 查询用户是否升级为代理
  jumpAgentLogin() {
    return new Promise((resolve, reject) => {
      const params = {
        UUID: $Cookies.get('UUID'),
        appType: 'pc'
      };
      $api.post($urls.USER.JUMPAGENTLOGIN, params, resp => {
        if (resp.data.code === 200) {
          resolve(resp)
        } else {
          resp.data.msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      });
    });
  },
  // 忘记密码-发送验证码
  sendPhoneCode(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.sendCode, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err)
      })
    })
  },
  // 共用方法，给当前登陆用户发送手机验证码
  sendCodeForPhone(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.sendCodeForPhone, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err)
      })
    })
  },
   // 验证手机
   phoneCodeVerification(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.phoneCodeVerification, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err)
      })
    })
  },
  // 忘记密码-重置密码
  confirm(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.confirm, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err)
      })
    })
  },
  // 注册
  register(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.REGISTER, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err)
      })
    })
  },
  // 获取提现列表
  getDepositList(params) {
    return request({
      url: $urls.USER.depositList,
      method: 'post',
      params: params
    })
  }
};

const SLOT = {
  // 我的收藏
  getMyslot() {
    return new Promise((resolve, reject) => {
      let datas = [];
      let params = {
        frontType: store.state.frontType,
        UUID: store.state.UUID,
        pageNo: -1,
        pageSize: 0,
      };
      $api.post($urls.SLOT.mySlot, params, resp => {
        if (resp.data.code === 200) {
          let datas;
          if (resp.data.data === null || resp.data.data === undefined) {
            datas = []
          } else {
            datas = resp.data.data.list
          }
          store.commit('SET_SLOT_COLLECTION', datas);
          resolve(datas)
        } else {
          store.commit('SET_SLOT_COLLECTION', datas);
          resolve(datas)
        }
      }, err => {
        reject(err.message)
      })
    });
  },
  // 我的收藏分页
  /**
   * frontType:，UUID:，pageNo:，pageSize: */
  getMyslotStep(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.mySlot, params, resp => {
        if (resp.data.code === 200) {
          let info = resp.data.data;
          let mySlot = common.slotJoint(store.state.picLink, info.list);
          let data = {
            list: mySlot,
            gameInfo: info
          };

          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    });
  },
  // 根据平台code 获取游戏
  getSlotGameByPlatform(params) {
    // let params = {
    //   platformCode: platformCode,
    //   frontType: this.frontType,
    //   pageNo: this.pageNo,
    //   pageSize: this.pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.GETSLOTGAMEPLATFORM, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 压码排行
  getSlotRank(pageSize) {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType,
        pageNo: 1,
        pageSize: pageSize,
      };
      $api.post($urls.SLOT.slotRank, params, resp => {
        if (resp.data.code === 200) {
          let data = common.joint(store.state.picLink, resp.data.data.list, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 获取最热游戏列表
  hotGameList(params) {
    return new Promise((resolve, reject) => {
      // let params = {
      //   frontType: store.state.frontType,
      //   pageNo: 1,
      //   pageSize: pageSize,
      // };
      $api.post($urls.HOMEBEFORE.GAMELIST, params, resp => {
        if (resp.data.code === 200) {
          let data = common.joint(store.state.picLink, resp.data.data.list, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 可能喜欢
  getMaybeLike() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType,
        UUID: store.state.UUID,
        pageNo: 1,
        pageSize: 4,
      };
      $api.post($urls.SLOT.maybeLike, params, resp => {
        if (resp.data.code === 200) {
          let data = common.oldJoint(store.state.picLink, resp.data.data, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },

  // 全部老虎机
  getTotalSlot(pageNo, pageSize) {
    let params = {
      frontType: store.state.frontType,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.totalSlot, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },

  // 老虎机游戏搜索
  selectGameSlotType(params) {
    // 老虎机筛选全选参数不用传,例如5-10线,传min=5,max=10,10线以下传min=10,50线以上传max=50," +
    // "type,1=奖池游戏,2=经典游戏,3=消消乐,4=电动角子，" +
    // "hotOrNew，0=最新游戏，5=热门游戏," +
    // "platformCode,平台编号
    // let params = {
    //   platformCode: '',
    //   min: '',
    //   max: '',
    //   type: '',
    //   hotOrNew: '',
    //   pageNo: '',
    //   pageSize: ''
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.selectGameSlotType, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },

  // 老虎机全部游戏
  selectAllGameSlotType(pageNo, pageSize) {
    let params = {
      platformCode: '',
      min: '',
      max: '',
      type: '',
      hotOrNew: '',
      frontType: store.state.frontType,
      pageNo: pageNo,
      pageSize: pageSize
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.selectGameSlotType, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data
          }
          resolve(result)
        } else {
          let result = {
            gameList: []
          }
          resolve(result)
        }
      }, err => {
        reject(err)
      })
    })
  },

  // 收藏
  addCollection(params) {
    // let params = {
    //   slotId: id,
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.addCollection, params, resp => {
        if (resp.data.code === 200) {
          resolve(true)
        } else {
          reject('请稍后再试')
        }
      }, err => {
        reject(err.message)
      });
    })
  },
  // 取消收藏
  cancelCollect(params) {
    // let params = {
    //   slotId: id,
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.cancelCollection, params, resp => {
        if (resp.data.code === 200) {
          resolve(true)
        } else {
          reject('请稍后再试')
        }
      }, err => {
        reject(err.message)
      });
    })
  },

  // 收藏(有收藏字段)
  getSlot(params) {
    // let params = {
    //   frontType: store.state.frontType,
    //   UUID: store.state.UUID,
    //   pageNo: -1,
    //   pageSize: 0,
    // };
    params['frontType'] = store.state.frontType;

    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.mySlot, params, resp => {
        if (resp.data.code === 200) {

          if (resp.data.data) {
            let gameList = resp.data.data.list;
            gameList = common.joint(store.state.picLink, gameList, store.state.mySlot);
            let gameInfo = resp.data.data;
            let result = {
              gameList: gameList,
              gameInfo: gameInfo,
            };
            resolve(result)
          } else {
            let result = {
              gameList: []
            };
            resolve(result)
          }

        }


      }, err => {
        reject(err.message)
      })
    })
  },

};

const WALLET = {
  // 账户刷新
  refresh() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.WALLET.refreshGameAccount, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 提现申请
  withdrawList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.WALLET.withdrawList, params, (resp) => {
        let data = resp.data.data;
        if (resp.data.code === 200) {
          resolve(data)
        } else if (resp.data.code !== 200) {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    });
  },
  // 投注记录
  gameHistory(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.WALLET.gameHistory, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data);
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    });
  }
};

const VIP = {
  // 获取账单信息
  myBalanceList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.myBalanceList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 账单详情
  getBalanceDetail(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.balanceDetail, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })

    })
  },
  // 站内信
  getMsgSiteList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.getMsgSiteList, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {})
    })
  },
  // 阅读站内信
  updateMsgSite(id) {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
        msgId: id,
      };
      $api.post($urls.VIP.updateMsgSite, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 删除站内信
  deleteMsgSite(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.deleteMsgSite, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {})
    })
  },
  // 发送站内信
  insertMsgSite(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.insertMsgSite, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {})
    })
  },
  // 邀请列表
  inviteList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.inviteList, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })

    })
  },
  // 领取邀请红利
  getInviteBonus(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.getInviteBonus, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // 邀请码
  inviteCode() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.VIP.inviteCode, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })

    })
  }
};

const PAY = {
  // USDT提现页面加载数据
  getUSDTAddress(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.getUSDTAddress,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  //  //获取手续费
  withdrawRate(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.withdrawRate,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 币钱包跳转接口
  covertVipWallet(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.covertVipWallet,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // V币充值
  apppayVippay(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.apppay_vippay,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // usdt充值接口
  apppay_usdt(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.apppay_usdt,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 获取首款地址
  queryUsdtAddress(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.queryUsdtAddress,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 获取所有链
  queryUsdtChain(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.queryUsdtChain,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 获取付款地址
  newUSDTList(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.newUSDTList,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  //-----------------支付宝----------------
  // 获取支付宝地址
  gainWithdrawAccount(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.gainWithdrawAccount,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // usdt充值
  payorder(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.payorder,
        params,
        resp => {
          if (resp.data.status === 0) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },

  // 获取usdt支付信息
  getUsdtWalletInfo(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.getUsdtWalletInfo,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 获取提现费率
  getFeeSetting(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.getFeeSetting,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  // 获取银行卡列表
  bankCardList() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID
      };
      $api.post(
        $urls.PAY.bankCardList,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            if (data === null) {
              data = [];
            }
            resolve(data);
          } else {
            resolve([]);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 添加银行卡
  addBank(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.addBankCard,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve("success");
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  // 验证银行卡信息
  checkBankCard(item) {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
        cardNumber: item.bankNumber
      };
      $api.post(
        $urls.PAY.checkBankCard,
        params,
        resp => {
          if (resp.data.code === 200) {
            item["picUrl"] = resp.data.data.picUrl;
            resolve(item);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 提款申请
  applyWithdraw(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.applyWithdraw,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve("success");
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 支付类型
  getPayType(UUID) {
    return new Promise((resolve, reject) => {
      let params = {
        deviceType: "pc",
        UUID: store.state.UUID
      };
      $api.post(
        $urls.PAY.payType,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 新支付类型
  getNewPayType(UUID) {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: UUID,
        deviceType: "pc"
      };
      $api.post(
        $urls.PAY.newPayType,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 获取支付的内容
  getPayConfig(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.payConfig,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 获取所有平台
  getAllPlatform() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID
      };
      $api.post(
        $urls.PAY.getAllPlatform,
        params,
        resp => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  // 取出全部的金额，用于提现等页面
  withdrawGames() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID
      };
      $api.post(
        $urls.PAY.withdrawGames,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve("success");
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  withdrawConfirm(params) {
    params.UUID = $Cookies.get("UUID");
    if (params.uploadImg) {
       return new Promise((resolve, reject) => {
      console.log("params.uploadImg", params.uploadImg);
      const formData = new FormData();
      formData.append("uploadImg", params.uploadImg);
      request({
        url:
          $urls.PAY.withdrawConfirm +
          `?UUID=${params.UUID}&transId=${params.transId}&transStatus=${params.transStatus}&content=${params.content}`,
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(resp => {
          if (resp.code === 200) {
            resolve("success");
          } else {
            let msg = resp.msg ? resp.msg : resp.message;
            reject(msg);
          }
        })
        .catch(err => {
          reject(err);
        });
    })
    } else {
      return new Promise((resolve, reject) => {
        $api.post(
          $urls.PAY.withdrawConfirm,
          params,
          resp => {
            if (resp.data.code === 200) {
              resolve("success");
            } else {
              let msg = resp.data.msg ? resp.data.msg : resp.data.message;
              reject(msg);
            }
          },
          err => {
            reject(err);
          }
        );
      });
    }
  },

  // 获取会员绑定的支付宝
  getUserApAccount(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.getUserApAccount,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 获取最小取款金额
  getMinAndMaxLimit(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.getLimit,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 绑定支付宝账号
  addAlipayAccount(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.addAlipayAccount,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  //添加支付宝地址
  newlyWithdrawAccount(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.newlyWithdrawAccount,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 删除地址
  deleteUSDT(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.deleteUSDT,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  // 设置默认地址
  setDefaultUSDT(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.setDefaultUSDT,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 添加地址
  addUSDT(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.addUSDT,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve(resp.data);
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 添加usdt支付账号
  addUSDTAccount(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.addUSDTAccount,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 查询USDT link types
  getUSDTLinkTypes() {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.usdtLinkTypeList,
        {},
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 获取会员所有的USDT钱包列表
  getUserAllUSDTList(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.selectUserAllUSDTList,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 会员删除USDT钱包
  userDeleteUSDT(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.userDeleteUSDT,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },
  // 设置默认USDT钱包
  setToDefaultUSDTAccount(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.userOperateUSDTConsent,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  },

  // 获取链名称对应的汇率
  getUSDTRate(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.PAY.getUsdtRate,
        params,
        resp => {
          if (resp.data.code === 200) {
            resolve({ message: "success", data: resp.data.data });
          } else {
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            reject(msg);
          }
        },
        err => reject(err.message)
      );
    });
  }
};

const HELP = {
  // 文章类型
  getArticleType(params = {}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HELP.articleType, params, resp => {
        if (resp.data.code === 200) {
          let navList = resp.data.data;
          resolve(navList)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },

  // 根据类型获取文章
  getArticleListByType(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HELP.articleListByType, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data);
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err.message)
      })
    });
  },
  // 根据文章ID获取文章内容
  articleById(id) {
    return new Promise((resolve, reject) => {
      let params = {
        articleId: id,
      }
      $api.post($urls.HELP.articleById, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data);
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err.message)
      })
    })
  }
};

const CONFIRM = {
  // 实名认证
  confirmRealName(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmRealName, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 提款密码验证码
  sendWithdrawYZM() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      }
      $api.post($urls.PAY.sendWithdrawYZM, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 设置提款密码
  setWithdrawPW(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.setWithdrawPW, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 修改提款密码
  updateWithdrawPW(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.updateWithdrawPW, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 修改登录密码
  updateLoginPassword(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.updateLoginPassword, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      });
    })
  },
  // 修改手机号验证码
  sendPhone(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.sendPhone, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 手机号认证
  confirmPhone(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmPhone, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      });
    })
  },
  // 邮箱发送邮件
  email(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.email, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      });
    })
  },
  // 邮箱认证
  confirmEmail(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmEmail, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 邮箱 认证 只需要邮箱
  submitEmail(params) {
    // params={
    //   UUID,
    //   email
    // }
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.submitEmail, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err.message)
      })
    })
  },
  // 获取电话验证国家列表
  queryCountryList(params = {}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.queryCountryList, params, resp => {
        if (resp.data.success) {
          resolve(resp.data.data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },

  //
  // QQ认证
  confirmQQ(params = {}) {
    // let params = {
    //   UUID,
    //   qq
    // }
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmQQ, params, resp => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 微信认证
  confirmWeChat(params = {}) {
    // let params = {
    //   UUID,
    //   weChat
    // }
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmWeChat, params, resp => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err)
      })
    })
  },
};

const GAME = {
  // 获取今日流水
  topFlowData(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.topFlowData, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err.message)
      })

    })
  },
  // 老虎机搜索
  searchResult(name) {
    return new Promise((resolve, reject) => {
      let params = {
        keyword: name,
      };
      $api.post($urls.GAME.searchResult, params, (resp) => {
        if (resp.data.code === 200) {
          let data = common.joint(store.state.picLink, resp.data.data, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err)
      })
    })
  },
  // 平台全部游戏
  allGame(platformCode, gameType, keyword, pageNo, pageSize) {
    let params = {
      platformCode,
      gameType,
      keyword,
      pageNo,
      pageSize,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.allGame, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          resolve({
            gameList: [],
            gameInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            },
          })
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 平台热门游戏
  hotGame(platformCode, gameType, pageNo, pageSize) {
    let params = {
      platformCode,
      gameType,
      pageNo,
      pageSize,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.hotGame, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          resolve({
            gameList: [],
            gameInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            },
          })
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 平台最新游戏
  newGame(platformCode, gameType, pageNo, pageSize) {
    let params = {
      platformCode,
      gameType,
      pageNo,
      pageSize,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.newGame, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          resolve({
            gameList: [],
            gameInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            },
          })
        }
      }, err => {
        reject(err)
      })
    })
  },
};

const DISCOUNTS = {
  // 获取优惠列表
  // let params = {
  //   offerTypes: -1 ,
  //   frontType:this.frontType,
  //   pageNo: this.pageNo,
  //   pageSize: this.pageSize,
  // };
  offerList(params = {}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.OFFERLIST, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 获取我的优惠列表
  myOffer(params = {}) {
    // let params = {
    //   UUID: this.UUID,
    //   filterType: this.filterType,
    //   pageNo: this.pageNo,
    //   pageSize: this.pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.MYOFFER, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        } else {
          let obj = {
            list: [],
            total: 0,
          };
          resolve(obj)
        }
      }, (err) => {
        reject(err.message)
      })

    })
  },
  // 优惠详情
  offerDetail(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.offerDetail, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err.message)
      })

    })
  },
  // 获取首页优惠图片
  getIndexOffer(params) {
    return new Promise((resolve, reject) => {
      // let pageNo = 1;
      // let pageSize = 6;
      // let params = {
      //   frontType: 2,
      //   pageNo,
      //   pageSize
      // };
      $api.post($urls.HOMEBEFORE.INDEXOFFER, params, resp => {
        if (resp.data.code === 200) {
          resolve(resp.data.data.list)
        } else {
          resolve([])
        }
      }, err => {
        reject(err)
      })
    })
  },
  // 获取优惠类型
  queryBonusArticleTypeList(params = {}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.queryBonusArticleTypeList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err.message)
      })

    })
  },
  //获取优惠列表（新）
  queryBonusArticleInfoList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.queryBonusArticleInfoList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err.message)
      })

    })
  },
  //活动大厅列表
  querySelfApplyBonusList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.querySelfApplyBonusList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err.message)
      })

    })
  },
  //活动大厅获取文章
  queryBonusArticleInfoDetail(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.queryBonusArticleInfoDetail, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {
        reject(err.message)
      })

    })
  },
}

const DEPOSIT = {
  // 申请存款红利
  applyBonus(params) {
    // let params = {
    //   platformKey: this.platformKey,
    //   viewOfferId: this.viewOfferId,
    //   applyAmount: this.applyAmount,
    //   betOrderNo: this.betOrderNo
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.applyBonus, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  otherApplyBonus(params) {
    return new Promise((resolve, reject) => {
      $api.post(
        $urls.DEPOSIT.otherApplyBonus,
        params,
        resp => {
          resolve(resp);
        },
        err => {
          reject(err.message);
        }
      );
    });
  },
  // 申请时时优惠
  applyRealTimeAmount(params) {
    // let params = {
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getRealTimeAmount, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 查看可领取的时时流水优惠列表
  realTimeAmount(params) {
    // let params = {
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.realTimeAmount, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 查询会员绑定优惠
  queryBonusBindUserInfoList(params) {
    // let params = {
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.queryBonusBindUserInfoList, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 升级查询
  selectUserUpgradeInfo(params) {
    // let params = {
    //   UUID,
    //   viewOfferId
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.selectUserUpgradeInfo, params, (resp) => {
        resolve(resp.data.data)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 大转盘抽奖 未登录
  queryTurntableRaffle() {
    let params = {
      activityType: 1
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.queryTurntableRaffle, params, (resp) => {
        resolve(resp.data)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 大转盘抽奖 已登录
  raffle() {
    let params = {
      activityType: 1
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.raffle, params, (resp) => {
        resolve(resp.data)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 历史中奖数据
  queryHistoryWin(params) {
    // let params = {
    //   activityType: 1,
    //   pageNo,
    //   pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.queryHistoryWin, params, (resp) => {
        let data = resp.data.data;
        if (data === null) {
          let obj = {
            list: [],
            pageInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            }
          };
          resolve(obj)
        }

        let list = data.list;
        let obj = {
          list: list,
          pageInfo: data
        };
        resolve(obj)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 大转盘真实中奖数据
  wheelActivityRealWin() {
    let params = {
      activityType: 1
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.wheelActivityRealWin, params, (resp) => {
        resolve(resp.data)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 领取红利
  receiveMyBonus(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.receiveMyBonus, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 签到活动
  signInActivityBonusInfo() {
    let params = {
      activityType: 1
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.signInActivityBonusInfo, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 更新签到进度
  updateSignInInfo(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.updateSignInSchedule, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 签到奖励
  getSignInPrizeHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getSignInPrizeInfo, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 额外奖励
  getOtherPrizeHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getOtherPrizeInfo, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 积分兑换
  exchangeScoreHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.exchangeScoreInfo, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // ============余额宝==========================
  // 查询可购买的余额宝列表
  checkAvailableYEBListHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.availableYEBList, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 查询已购买的余额宝列表
  checkPurchasedYEBListHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.purchasedYEBList, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 购买余额宝
  buyYEBProgramHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.buyYEBProgram, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 赎回余额宝
  ransomYEBProgramHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.ransomYEBProgram, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },


};
const QUESTION = {
  // ===========问卷==========================
  //获得当前启动的问卷
  getTotalQuestionnaire(params) {
    return new Promise((resolve, reject) => {
      $api.get($urls.QUESTION.totalQuestionnaire+'?userId='+params.userId, {},(resp) => {
        resolve(resp)
      }, (err) => {
        reject(err)
      })
    })
  },
  //提交问卷
  submitQuestionnaire(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.QUESTION.submitQuestionnaireIri, params,(resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      },'json')
    })
  },
  //领取问卷奖励
  getquestionAward(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.QUESTION.getAwardIri, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  }
};

const SPORT = {
  // 申请存款红利
  sport(sportId, market) {
    let params = {
      sportId: sportId,
      market: market
    }
    return new Promise((resolve, reject) => {
      $api.post($urls.SPORT.sport, params, (resp) => {
        resolve(resp.data)
      }, (err) => {
        reject(err.message)
      })
    })
  }
}

const commonApi = {
  HOMEBEFORE,
  HOMEAFTER,
  DISCOUNTS,
  USER,
  SLOT,
  WALLET,
  VIP,
  PAY,
  HELP,
  CONFIRM,
  GAME,
  DEPOSIT,
  QUESTION,
  SPORT
};
export default commonApi



// WEBPACK FOOTER //
// ./src/common/utils/commonApi.js